import React from "react";
import { MemoryRouter, Routes, Route } from "react-router-dom";
import AccountCreateComponent from "./components/account-create";
import AccountSuccessComponent from "./components/account-success";
import AccountExistsComponent from "./components/account-exists";
import AccountExpiredComponent from "./components/account-expired";
import AccountFailedComponent from "./components/account-failed";

function App() {
  return (
    <MemoryRouter>
      <Routes>
        <Route path="/" element={<AccountCreateComponent />} />
        <Route path="/success" element={<AccountSuccessComponent />} />
        <Route path="/already-exists" element={<AccountExistsComponent />} />
        <Route path= "/expired" element={<AccountExpiredComponent />} />
        <Route path = "/failed" element={<AccountFailedComponent />} />
      </Routes>
    </MemoryRouter>
  );
}

export default App;
